import type React from 'react';
import { CurrencySelector } from 'components/ui/currency-selection';
import SubmissionDetailsTab from 'components/features/submission-details-tab';
import { uniq } from 'lodash';
import { useState } from 'react';
import { LayerStructureTable } from '../layer-structure-table';
import { DEFAULT_CONVERSION_CURRENCY } from './types';
import BasisOfCoverTable from '../basis-of-cover-table';
import { ESubmissionDetailsTabsKeys } from 'components/features/submission-details-tab/types';
import { SubmissionTabProps } from 'routes/Submissions/SubmissionDetail/navigation-tab/submission-config-tabs';
import SubLimitsConfiguration from '../sub-limits-configuration';
import { BusinessLineResponseDtoNameEnum } from 'libs/pinnacle-sdk';
import { BUSINESS_LINE_FOR_PRICING_MODEL } from 'constants/price-rating';

const SubmissionDetails: React.FC<SubmissionTabProps> = ({
  submission,
  includeBack,
  includeNext,
  navigateBack,
  navigateNext,
}) => {
  const [activeTab, setActiveTab] = useState<string>(
    ESubmissionDetailsTabsKeys.LayerStructures
  );
  const [selectedCurrency, setSelectedCurrency] = useState(
    submission.originalCurrency || DEFAULT_CONVERSION_CURRENCY
  );

  return (
    <div className="rounded-lg bg-[#E3F2FB]">
      <div className="flex items-center justify-between">
        <div className="pt-2">
          <SubmissionDetailsTab
            activeTab={activeTab}
            onTabChange={setActiveTab}
            businessLine={
              submission.lineOfBusiness as BusinessLineResponseDtoNameEnum
            }
          />
        </div>
        {activeTab === ESubmissionDetailsTabsKeys.LayerStructures && (
          <div className="pb-2">
            <CurrencySelector
              defaultValue={selectedCurrency}
              currencies={uniq([
                DEFAULT_CONVERSION_CURRENCY,
                ...(submission.originalCurrency
                  ? [submission.originalCurrency]
                  : []),
              ])}
              onChange={setSelectedCurrency}
            />
          </div>
        )}
      </div>
      {activeTab === ESubmissionDetailsTabsKeys.LayerStructures && (
        <LayerStructureTable
          submission={submission}
          selectedCurrency={selectedCurrency}
          includeBack={includeBack}
          includeNext={includeNext}
          navigateBack={navigateBack}
          navigateNext={() => {
            if (
              !BUSINESS_LINE_FOR_PRICING_MODEL.includes(
                submission.lineOfBusiness as BusinessLineResponseDtoNameEnum
              )
            ) {
              navigateNext(5);
            } else {
              setActiveTab(ESubmissionDetailsTabsKeys.SubLimits);
            }
          }}
        />
      )}
      {activeTab === ESubmissionDetailsTabsKeys.SubLimits && (
        <SubLimitsConfiguration
          submission={submission}
          includeNext={includeNext}
          includeBack={includeBack}
          navigateNext={() =>
            setActiveTab(ESubmissionDetailsTabsKeys.BasisOfCover)
          }
          navigateBack={() =>
            setActiveTab(ESubmissionDetailsTabsKeys.LayerStructures)
          }
        />
      )}
      {activeTab === ESubmissionDetailsTabsKeys.BasisOfCover && (
        <BasisOfCoverTable
          submission={submission}
          includeNext={includeNext}
          includeBack={includeBack}
          navigateNext={navigateNext}
          navigateBack={() =>
            setActiveTab(ESubmissionDetailsTabsKeys.SubLimits)
          }
        />
      )}
    </div>
  );
};

export default SubmissionDetails;
